import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  CopyMapModalContainer, type CopyMapModalContainerProps,
} from './copyMapModal.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    CopyMap: CopyMapModalContainerProps;
  }
}
modalRenderer.register('CopyMap', CopyMapModalContainer);
